import { render, staticRenderFns } from "./ProjectGroupManagementRemarks.vue?vue&type=template&id=15ed0bc7"
import script from "./ProjectGroupManagementRemarks.vue?vue&type=script&lang=js"
export * from "./ProjectGroupManagementRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports